import React from "react";

import CountUp from 'react-countup';
import { statusGoalsList } from "utils/status";


export function ContentWidget({ goals, language = ''}) {

    const totalFoals = goals.reduce((acumulator, object) => {
        return acumulator + object.value;
    }, 0);

    const ItemList = ({goalData}) => {
        const { iconColor, icon, label } = statusGoalsList.find(item => item.status === goalData.key)

        return (
            <div className="list-group-item" style={{borderLeft: 0, borderRight: 0}}>
                <div className="d-flex justify-content-between align-items-center">
                    <span className="text-sm">
                       <i className={`bi ${icon} fs-5 me-2 text-${iconColor}`} />
                        {label}
                    </span>
                    <span className="text-sm">
                        <CountUp end={goalData.value} duration={0.5}/>
                    </span>
                </div>
            </div>
        )
    }

    return (
        <div className="col widget-card">
            <div className="card mb-2 shadow-sm border-0">
                <div className="card-body p-0 position-relative">

                    <div className="d-flex justify-content-between pb-0 p-3">

                        <div className="mt-3 ms-4">
                            <span className="text-muted text-sm">
                                {language === 'pt-BR' ? 'Português' : 'Inglês'}
                            </span>
                            <h4 className="mb-0 fs-2 fw-normal">
                                <CountUp end={totalFoals} duration={0.5}/>
                            </h4>
                        </div>

                        <span className="rounded-circle layout-fixed bg-light py-3 px-4 me-3">
                            <i className="bi bi-bar-chart fs-3 text-primary text-opacity-100"/>
                        </span>
                    </div>

                    <div className="mt-3">
                        <div className="accordion" id={`collapse${language}`}>
                            <div className="accordion-item m-0 border-0">
                                <div id={`collapse-${language}`} className="accordion-collapse collapse">
                                    <div className="accordion-body px-0 pb-0">

                                        <div className="list-group rounded-0">
                                            {goals.map(goal =>
                                                <React.Fragment key={goal.key}>
                                                    <ItemList goalData={goal}/>
                                                </React.Fragment>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <h2 className="accordion-header border-0 border-top rounded-0">
                                    <button
                                        className="accordion-button shadow-none rounded-0 rounded-bottom"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse-${language}`}
                                        aria-expanded="false"
                                        aria-controls={`collapse-${language}`}
                                    >
                                        Detalhes
                                    </button>
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        // <div className="widget-card">
        //     <div className="card mb-2 shadow-sm border-0">
        //         <div className="card-body p-0">
        //             <div className="d-flex justify-content-between pb-0 p-3">
        //
        //                 <div className="mt-3 ms-4">
        //                     {isLoading || isFetching
        //                         ? <Loading width="50px"/>
        //                         : <h4 className={`mb-0 text-${color} fs-2 fw-normal`}> <CountUp end={total} duration={0.5}/></h4>
        //                     }
        //                 </div>
        //
        //                 <span className={`rounded-circle layout-fixed bg-light py-3 px-4 me-3`}>
        //                         <i className={`bi ${icon} fs-3 text-${color} text-opacity-100 `} />
        //                 </span>
        //
        //             </div>
        //
        //             <div className={`text-center mt-3 p-2 bg-${color} bg-opacity-25 rounded-bottom`}>
        //                 <p className={` pb-0 mb-0 text-${color} fw-light`}>{i18n.t(`header.${status ? param === 'goals' && status === 'all' ? 'allGoal' : status : 'delete'}`)}</p>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    );
}
